@if (CompanyId && LoggedInUser) {
  <div class="container-fluid">
    <!-- VPDW-3111: Unified page header with title + ALL action buttons
         on one row. Previously the buttons were scattered across 2-3
         rows (parent + child component). -->
    <div class="page-head">
      <div>
        <h1 class="page-title">
          {{ title }}
          @if (subTitle) {
            <span class="page-subtitle">{{ subTitle }}</span>
          }
        </h1>
        @if (filterText) {
          <div class="d-flex align-items-center gap-2 mt-2">
            <a
              class="underline cursor-select"
              (click)="goToVendorSearchPage()"
              >{{ filterText }}</a
            >
            <i
              class="bi bi-x-lg cursor-select"
              style="color: var(--color-text-secondary)"
              (click)="clearVendorSearchFilter()"
            ></i>
          </div>
        }
      </div>
      <div class="action-row">
        <div class="form-check form-switch d-flex align-items-center m-0">
          <input
            class="form-check-input me-1"
            type="checkbox"
            role="switch"
            id="showMapSwitch"
            [(ngModel)]="showMap"
          />
          <label class="form-check-label m-0" for="showMapSwitch">{{
            showMap ? 'Hide map' : 'Show map'
          }}</label>
        </div>
        <button class="btn btn-outline" (click)="findAVendorTutorialVideo()">
          Find a vendor tutorial
        </button>
        @if (view === 'client' && canShowAddVendorTutorial && canAddVendor) {
          <button class="btn btn-outline" (click)="proxyAddVendorTutorial()">
            Add vendor tutorial
          </button>
        }
        @if (LoggedInUser.UserAccountRole?.role === 'CLIENT_ADMIN') {
          <button class="btn btn-outline" (click)="displaySimpleSearchModal()">
            Show simple search
          </button>
        }
        @if (canAddVendor) {
          <button class="btn btn-primary" (click)="proxyAddVendor()">
            Add new vendor
          </button>
        }
        @if (canInviteVendor) {
          <button class="btn btn-primary" (click)="proxyInviteVendor()">
            Invite vendor
          </button>
        }
      </div>
    </div>

    @if (showMap) {
      <div class="row row-padding-bottom">
        <div class="col vh-50">
          <app-geo-map
            [coordinateInfo]="LocationNamesAndCoordinates"
            [DefaultCoordinate]="DefaultCoordinate"
            [centeredCoordinate]="CenteredCoordinate"
            (featureClick)="featureClicked($event)"
          ></app-geo-map>
        </div>
      </div>
    }
    <div class="row row-padding-bottom">
      <div class="col g-0 vh-100 pb-2">
        @if (view === 'client' && CompanyVendorQuery) {
          <app-client-my-vendors
            #clientMyVendors
            [AdditionalQueryData]="CompanyVendorQuery"
            [OriginalQueryData]="clonedVendorQuery"
            [currentNavigationData]="currentNavigationData"
            [CompanyId]="CompanyId"
            [FilterModel]="FilterModel"
            [Filters]="Filters"
            [FilterModel]="FilterModel"
            (dataGridQueryChanged)="handleCompanyVendorGridQueryChange($event)"
            (companyLoaded)="onMyVendorsCompanyLoaded()"
          ></app-client-my-vendors>
        }
        @if (view === 'vive' && VendorQuery) {
          <app-client-vive-vendors
            #clientViveVendors
            [AdditionalQueryData]="VendorQuery"
            [OriginalQueryData]="clonedVendorQuery"
            [CompanyId]="CompanyId"
            [country]="country"
            (dataGridQueryChanged)="handleVendorGridQueryChange($event)"
          ></app-client-vive-vendors>
        }
      </div>
    </div>
  </div>
}
